import { Injectable } from '@angular/core'
import { Subject } from 'rxjs'

@Injectable({
  providedIn: 'root'
})
export class FcMenuService {
  public close$ = new Subject<void>()
}
